<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>دعوت از دوستان و همکاران </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2" v-for="item in InviteUserList" :key="item.inviteId">

                <div class="py-2 px-3" :id="'Invite-'+item.InviteId">
                    <button data-toggle="collapse" type="button" :data-target="'#collapse-'+item.inviteId" class="no-effect collapsed accordion-btn" aria-expanded="false">
                        <span class="d-flex justify-content-between align-items-center">
                            <span class="d-flex flex-column">
                                <span class="font-16 text-dark py-2"><i class="fa fa-user color-green2-dark ml-3"></i>دریافت کننده: <b>{{item.toUser}}</b></span>
                                <span class="font-14 text-muted py-2"><i class="fa fa-calendar color-magenta1-light ml-3"></i>زمان درخواست: <b class="d-inline-block ltr">{{item.strRequestDateTime}}</b></span>
                            </span>
                            <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                        </span>
                    </button>
                </div>

                <div class="collapse border-t" :id="'collapse-'+item.inviteId">
                    <div class="d-flex justify-content-between py-2 pr-4 pl-3">
                        <div style="width:90%">
                            <div>
                                <i class="fa fa-check-circle color-green1-light ml-3"></i>
                                <span class="text-muted">زمان مشاهده: <b class="d-inline-block ltr">{{item.strViewDateTime}}</b></span>
                            </div>
                            
                        </div>
                        <span class="text-left" @click.stop="showMenu(item)" style="width:10%"><i class="fa fa-ellipsis-v font-14"></i></span>
                    </div>
                    <div class="px-4 pb-3">
                        <i class="fa fa-check-circle color-green1-light ml-3"></i>
                        <span>وضعیت ارسال: <b>{{item.sendMessageLog}}</b></span>
                    </div>
                    <div class="px-4 pb-3">
                        <i class="fa fa-check-circle color-green1-light ml-3"></i>
                        <span>وضعیت: <b>{{item.invitedUserRegistrationStatue}}</b></span>
                    </div>

                    <div class="px-4 pb-3">
                        <i class="fa fa-check-circle color-green1-light ml-3"></i>
                        <span>تاریخ پاسخ: <b class="d-inline-block ltr">{{item.strResponseDateTime}}</b></span>
                    </div>
                    <div class="px-4 pb-3">
                        <i class="fa fa-check-circle color-green1-light ml-3"></i>
                        <span>گروه های کاری: <b>{{item.workGroupTitle}}</b></span>
                    </div>

                </div>


            </div>

            <!--<div class="card card-style text-center mb-3">
                <div class="content">

                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div py-2" v-for="item in InviteUserList" :key="item.InviteId">
                            <div class="d-flex align-items-center justify-content-between">-->
                                <!--<input class="big-checkbox UserSelected" type="checkbox" :value="task.userId" :id="task.userId" :key="task.userId" />-->

                                <!--<a class="border-0" target="_blank" :href="item.url">
                                    <div class="d-flex">
                                        <i class="fa fa-bullhorn text-primary px-3 float-none font-13 opacity-1"></i>
                                        <p class="mb-0 rtl text-right">زمان درخواست: {{item.strRequestDateTime}}</p>
                                    </div>
                                    <div class="d-flex">
                                        <i class="fa fa-barcode color-pink2-light px-3"></i>
                                        <p class="mb-0"> دریافت کننده: <b>{{item.toUser}}</b></p>
                                    </div>

                                    <div class="d-flex">
                                        <i class="fa fa-barcode color-pink2-light px-3"></i>
                                        <p class="mb-0"> زمان مشاهده: <b>{{item.strViewDateTime}}</b></p>
                                    </div>
                                    <div class="d-flex">
                                        <i class="fa fa-barcode color-pink2-light px-3"></i>
                                        <p class="mb-0"> وضعیت ارسال: <b>{{item.sendMessageLog}}</b></p>
                                    </div>
                                    <span class="text-left" style="width:10%" @click.stop="showMenu(item)"><i class="fa fa-ellipsis-v ml-0 font-14"></i></span>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-if="pageLoaded==true && isFreeRegist!==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/InviteUserPage" class="btn px-3 py-2 rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">

                    <button @click="deleteInvite" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>

    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    export default {
        data() {
            return {
                selectedInviteId: 0,
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedTypeId: 0,
                pageLoaded: false
            };
        },
        computed: {
            InviteUserList() {
                return this.$store.getters.GetInviteUserList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },
        created() {
            this.$store.dispatch("GetInviteUserListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
			showAddButton() {
				this.pageLoaded = true;
			},
            showMenu(t) {
                this.selectedInviteId = t.inviteId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            deleteInvite() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.$http
                        .get("InviteUser/Delete?id=" + this.selectedInviteId)
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                document.getElementsByClassName("menu-hider")[0].click();
                                this.page = 1;
                                this.$store.dispatch("GetInviteUserListFromServer", {
                                    pageId: this.page,
                                    filterId: this.filterId,
                                    searchKey: this.searchKey
                                });
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                });
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetInviteUserListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
		mounted() {
			this.showAddButton();
			document
				.querySelectorAll(".menu-box-right")
				.forEach((a) => (a.style.display = "block"));
		},
    }
</script>